<script>
    export default {
        data() {
            return {
                media: window.ViewPort.media,
            };
        },
        mounted() {
            window.EventHandler.listen('window-resized', data => this.media = data.media);
        },
    };
</script>
